// extracted by mini-css-extract-plugin
export var cardContainer = "_ns-0";
export var cardHeader = "_ns-2";
export var collapsedState = "_ns-3";
export var dragHandle = "_ns-5";
export var dragHandleIcon = "_ns-6";
export var dragging = "_ns-1";
export var titleArea = "_ns-4";